import { OverviewDateType } from '@/pages/EnergyStatisticalReport/const';
import {
  formatThousandUnitDefaultTwo,
  keepPercentTwoNull,
  keepTwoOrNull,
  keepTwoWithNumberOrLine,
} from '@/utils/utils';
import { Progress, ProgressProps } from 'antd';
import { isNil } from 'lodash-es';
import React, { useContext } from 'react';
import { ShareDataWrapperContext } from '../..';
import styles from './index.module.scss';

const twoColors: ProgressProps['strokeColor'] = {
  '0%': '#79EDE4',
  '100%': '#44D7B8',
};

interface CostRateBoxProps {
  showPlanCost: boolean;
}

const CostRateBox = ({ showPlanCost }: CostRateBoxProps) => {
  const { overviewData, timeResolution } = useContext(ShareDataWrapperContext);

  return (
    <div className={styles.costRate_wrapper}>
      <div className={styles.rate_progress}>
        <Progress
          type="circle"
          size={100}
          percent={!isNil(overviewData?.ratio) ? keepTwoOrNull(overviewData?.ratio)! : undefined}
          strokeColor={twoColors}
          trailColor="#28323F"
          strokeWidth={12}
          format={() => {
            return <span style={{ fontSize: 14 }}>{keepTwoWithNumberOrLine(overviewData?.ratio)}%</span>;
          }}
        />
      </div>
      {showPlanCost && (
        <div className={styles.cost}>
          <div className={styles.label}>{timeResolution === OverviewDateType.MONTH ? '本月' : '本年'}计划成本</div>
          <div className={styles.value}>{formatThousandUnitDefaultTwo(overviewData?.planCost)}元</div>
        </div>
      )}
      <div className={styles.cost}>
        <div className={styles.label}>实际总成本</div>
        <div className={styles.value}>{formatThousandUnitDefaultTwo(overviewData?.totalCost)}元</div>
      </div>
    </div>
  );
};

export default CostRateBox;
